import React, { useEffect, useState } from 'react';
// import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import { useHistory, useLocation } from 'react-router';
// import TextField from '@material-ui/core/TextField';
// import Radio from '@material-ui/core/Radio';

import { Grid } from '@material-ui/core';
import axios from 'axios';
import Tooltip from '@material-ui/core/Tooltip';
import { useSelector } from 'react-redux';
import './styles.css';
import FinalImage from '../../assets/downimage.png';
import { CommonConfig } from '../../config/common-config';
import LoaderPopUp from '../../components/loaderpopup/loader';
import SuccessPopUp from '../../components/loaderpopup/success';
import ErrorPopUp from '../../components/loaderpopup/error';
import PreviewImage from '../../assets/previewImage.png';
import downloadImage from '../../assets/downloadImage.png';
import PreviewModal from '../../components/modal/previewModal';
import TabList from '../../components/checklistTab/tabList';
import { userType } from '../../config/usertypeValue';

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: '0px 5px 10px #efefef !important',
        borderRadius: '8px',
        minHeight: '300px',
        // padding: '20px',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        color: '#727272',
        fontSize: '20px',
        fontFamily: 'Rubik',
        fontWeight: '500',
        marginBottom: '20px',
    },
    pos: {
        marginBottom: 12,
    },
    rootCard: {
        marginBottom: '20px',
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '& > *': {
            margin: theme.spacing(1),
        },
    },

    bottomLine: {
        padding: '0',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    inlineDisplayFont: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 20px',
            color: '#7779ba',
            marginTop: '-10px',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        margin: '0 10px !important',
        minWidth: '200px',
    },
    inlinebutton: {
        padding: '0',
        margin: '0',
        '& li': {
            listStyle: 'none',
            display: 'inline-block',
            marginRight: '15px',
        },
    },
}));

export default function IMCReports() {
    const location = useLocation();
    const history = useHistory();
    const classes = useStyles();
    // const bull = <span className={classes.bullet}>•</span>;
    const [state, setState] = useState({
        checkedA: true,
    });
    const [finalCompFilename, setFinalCompFilename] = useState();
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const tennantName = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [visible, setVisible] = React.useState(false);
    const coreFilename = [];
    const [downloadPath, setDownloadPath] = useState('');
    const [URLPath, setURLPath] = useState('');
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };

    useEffect(() => {
        if (location && location.state && location.state.finalCompFile) {
            const filename = location && location.state && location.state.finalCompFile;
            setFinalCompFilename(filename.substring(filename.lastIndexOf('-') + 1));
            setURLPath(filename);
        }
        if (userType && userType.compFile) {
            const filename = userType.compFile;
            setFinalCompFilename(filename.substring(filename.lastIndexOf('-') + 1));
            setURLPath(filename);
        }
    }, []);


    const handleNavigate = (event) => {
        ////console.log('location', location.state);
        // history.push({
        //     pathname: '/menu/client-final-doc-approval',
        // });
    };

    const handleClose = () => {
        setShowBtnLoader(false);
    }

    const handleNavigateForInvoices = (event) => {

        history.push({
            pathname: '/menu/request-invoice',
        });


        // setShowBtnLoader(true);
        // const data = {
        //     serviceId: serviceIdValue,
        //     remarks: 'Remarks',
        //     finalDocumentAndReports: {
        //         finalComputationDocument: location.state.finalCompFile,
        //         itrAcknowledgement: location.state.itrFile,
        //         taxChalanOrAcknowledgement: location.state.taxChallanFile,
        //         transferToAccount: false,
        //         payonline: true,
        //         stage: 'finalDocumentAndReports',
        //         descriptionForInvoice: 'descriptionForInvoice',
        //         amountForInvoice: '1111',
        //         reports: 'Structure is not finalized',
        //     },
        // };

        //console.log('handleSubmitClick', data);

        // axios
        //     .put(`${CommonConfig.dev.baseUrl1}/api/itr/final-computation/request-invoice/Advith`, data, {
        //         headers: {
        //             Authorization: bearerToken,
        //         },
        //     })
        //     .then((response) => {
        //         //console.log('ClientFinalDocResponse', response.data);
        //         if (response.data === 'SUCCESS') {
        //             setShowBtnLoader(true);
        //             setTimeout(() => {
        //                 setShowBtnLoader(false);
        //                 setSuccessPop(true);
        //             }, 1500);
        //             setTimeout(() => {
        //                 history.push({
        //                     pathname: '/menu/request-invoice',
        //                 });

        //             }, 3000);
        //         }
        //     })
        //     .catch((error) => {
        //         const errResult = error.response;
        //         if (errResult.data) {
        //             setShowBtnLoader(true);
        //             setTimeout(() => {
        //                 setShowBtnLoader(false);
        //                 setErrorPop(true);
        //             }, 1500);
        //             setTimeout(() => {
        //                 setErrorPop(false);
        //             }, 5000);
        //             setErrorMsgGenerateRecceipt(errResult.data.message);
        //         }
        //     });
    };

    const downloadFile = () => {
        axios
                .get(`${CommonConfig.dev.baseUrl}/api/auth/mergedpdffile/${serviceIdValue}/${tennantName}`
                , {
                headers: {
                    Authorization: bearerToken,
                },
                responseType: 'blob',
                }
                )

            .then((response) => {
                const link = document.createElement('a');
                ////console.log('link480', link);

                link.href = response.config.url;
                link.setAttribute('download', response.config.url);

                // Start download
                link.click();
            });
    };

    const handleModalClose = () => {
        setVisible(false);
    }

    const handlePreviewModal = (file) => {
        setDownloadPath(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setShowBtnLoader(true);
        setTimeout(() => {
            setShowBtnLoader(false);
            setVisible(true);
        }, 1000);
    }

    return (
        <div>
            {showBtnLoader ? (<LoaderPopUp showLoader={showBtnLoader} handleClose={handleClose} title="Please wait" />) : null}
            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Request has been sent successfully" />) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />) : null}
            <div>
                {/* <div className="stage-indicator">
                    <ul>
                        <li>L1 Checklist</li>
                        <li>L1 CRC Confirmed</li>
                        <li>Detailed Analysis</li>
                        <li>Draft Statements</li>
                        <li>Tax Payment and Filing</li>
                        <li className="active">Reports</li>
                    </ul>
                </div> */}
                <TabList />

                <form className="itecform">
                    <Card className={classes.root}>
                        <CardContent>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={12} className="text-center">
                                    <img src={FinalImage} alt="final-img" />
                                </Grid>
                                <Grid item xs={12} sm={12} className="text-center">
                                    <FormControl fullWidth className="mt50 mb50 btn-center">
                                        <Button variant="outlined" color="primary" size="small" className={classes.button} onClick={downloadFile}>
                                            {/* Download final computation document */}
                                            {/* Download Tax Payment Document */}
                                            Download ITR Final Documents
                                        </Button>
                                        {/* <p style={{ textAlign: 'center' }}>{finalCompFilename}</p> */}
                                        {/* <div style={{ paddingBottom: '12px', textAlign: 'center' }}>
                                            <span className="fileName" style={{ textAlign: 'start', marginRight: '12px' }}>{finalCompFilename}</span>
                                            {finalCompFilename ?
                                                <span onClick={() => handlePreviewModal(URLPath)}>
                                                    <Tooltip title="Preview">
                                                        <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                    </Tooltip>
                                                </span> : null}
                                        </div>
                                        <PreviewModal
                                            fileSource={downloadPath}
                                            visibleClose={visible}
                                            handleModalClose={handleModalClose}
                                        /> */}
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                    <div className="footer-button">
                        <ul>
                            {/* <li>
                            <Button color="primary" className="buttonnext txt-cap" onClick={handleNavigate}>
                                Send to Client
                            </Button>
                        </li> */}
                            <li>
                                <Button color="primary" className="buttonnext txt-cap" onClick={handleNavigateForInvoices}>
                                    Request for Invoice
                                </Button>
                            </li>
                        </ul>
                    </div>
                </form>
            </div>
        </div>
    );
}
